import React from "react";

export const Footer = () => (
  <footer className="bg-ink text-white">
    <div className="max-w-6xl mx-auto px-6 py-14">
      <div className="grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2.5">
            <img src="/kashbaaki-logo-white.png" alt="KashBaaki" className="h-9 w-auto object-contain" />
          </div>
          <p className="mt-4 text-sm text-white/60 leading-relaxed max-w-xs">
            Delayed-payment recovery for Indian Micro &amp; Small Enterprises under the
            MSMED Act, 2006.
          </p>
          <div className="mt-6" data-testid="footer-kashsam">
            <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-white/40">
              A product by
            </div>
            <img
              src="/kashsam-logo-white.png"
              alt="Kashsam Data Solutions"
              className="mt-2 h-9 w-auto object-contain"
            />
          </div>
        </div>
        <div>
          <div className="font-mono text-[11px] uppercase tracking-[0.16em] text-white/50">Product</div>
          <ul className="mt-4 space-y-2 text-sm text-white/70">
            <li><a href="#how" className="hover:text-white transition-colors duration-150">How it works</a></li>
            <li><a href="#demo" className="hover:text-white transition-colors duration-150">Live demo</a></li>
            <li><a href="#pricing" className="hover:text-white transition-colors duration-150">Pricing</a></li>
            <li><a href="#waitlist" className="hover:text-white transition-colors duration-150">Join waitlist</a></li>
          </ul>
        </div>
        <div>
          <div className="font-mono text-[11px] uppercase tracking-[0.16em] text-white/50">Legal</div>
          <p className="mt-4 text-xs text-white/60 leading-relaxed">
            Informational tool, not legal advice. KashBaaki does not create an advocate–client
            relationship. Consult a qualified advocate before serving any notice or filing
            before the MSEFC / Samadhaan.
          </p>
        </div>
      </div>
      <div className="mt-12 pt-6 border-t border-white/15 flex flex-wrap items-center justify-between gap-3 text-xs text-white/50">
        <span className="font-mono">© {new Date().getFullYear()} KashBaaki · Product by Kashsam · Phase 1 Demo</span>
        <span className="font-mono">MSMED Act, 2006 · §15–18 · DPDP Act, 2023</span>
      </div>
    </div>
  </footer>
);
